import _createClass from "/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Info } from './info.js';
import * as types from './types.js';
/** @type {Array<keyof types>} */
// @ts-expect-error: hush.

var checks = Object.keys(types);
export var DefinedInfo = /*#__PURE__*/function (_Info) {
  _inherits(DefinedInfo, _Info);

  var _super = _createSuper(DefinedInfo);

  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;

    _classCallCheck(this, DefinedInfo);

    var index = -1;
    _this = _super.call(this, property, attribute);
    mark(_assertThisInitialized(_this), 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        var check = checks[index];
        mark(_assertThisInitialized(_this), checks[index], (mask & types[check]) === types[check]);
      }
    }

    return _this;
  }

  return _createClass(DefinedInfo);
}(Info);
DefinedInfo.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */

function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
  }
}